const Core = require('./core');
const Actions = require('./actions');

module.exports = {
  startSession: Core.startSession,
  startGtmSession: Core.startGtmSession,
  endSession: Core.endSession,

  actions: Actions
};
